// Reading the scroll position of a column-reverse list.
//
// The conversation is drawn bottom up, which is how WhatsApp and Telegram avoid
// scrolling on open: a scroll container starts at position 0, and in an
// inverted list position 0 is already the newest message, so the first paint is
// the bottom of the conversation with no scrolling to watch.
//
// The cost is that scrollTop no longer means what it usually does. Browsers do
// not agree on whether scrolling up in such a container counts away from zero
// or below it: Chrome reports negative numbers, others report positive. Trust
// the sign and the list only works in one engine, which is how the reader ended
// up stuck at the top on a phone. So the distance is measured and the sign
// thrown away.

// Within this many pixels of the newest message the reader counts as being at
// the bottom, so an arriving message may pull the view down. Further up they
// are reading history and must not be moved.
export const AT_BOTTOM_PX = 40;

// How close to the oldest loaded message the reader gets before the next page
// is fetched. Far enough ahead that the page is usually there by the time they
// arrive.
export const NEAR_TOP_PX = 120;

export const measureInvertedScroll = (area) => {
  if (!area) return null;
  const fromBottom = Math.abs(area.scrollTop);
  const fromTop = area.scrollHeight - area.clientHeight - fromBottom;
  return {
    fromBottom,
    fromTop,
    atBottom: fromBottom < AT_BOTTOM_PX,
    nearTop: fromTop < NEAR_TOP_PX,
  };
};

export default measureInvertedScroll;
